export enum Interactable_types {
    stair= 10,
    chest,
    nest,
}